import { Button, ButtonProps, styled } from "@mui/material";

import { Link } from "react-router-dom";

const ButtonStyled = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    ".text": {
      display: "none",
    },
    "& > span": {
      margin: 0,
    },
    padding: theme.spacing(0.75),
    minWidth: "auto",
  },
})) as typeof Button;

const ButtonComponent = (
  props: Pick<
    ButtonProps,
    "href" | "children" | "startIcon" | "variant" | "color"
  >,
) => {
  if (props.href) {
    return (
      <ButtonStyled {...props} component={Link} to={props.href}>
        <span className={"text"}>{props.children}</span>
      </ButtonStyled>
    );
  }

  return (
    <ButtonStyled {...props}>
      <span className={"text"}>{props.children}</span>
    </ButtonStyled>
  );
};

export const DynamicButton = ButtonComponent as typeof Button;
